import React from "react";
import { useHistory } from "react-router-dom";
import Bpmn from "../../Componnets/Bpmn/Bpmn";

const ShowBpmn = () => {

  const history = useHistory()
  const search = new URLSearchParams(history.location.search)
  const url = `${search.get('url')}&Signature=${encodeURIComponent(search.get('Signature'))}&Expires=${search.get('Expires')}`;

  return (
    <div style={{height: "100%"}}>
      <Bpmn
        url={url}
      />
    </div>
  )
};

export default ShowBpmn;